var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"pull-right hidden-xs"},[_c('b',[_vm._v(_vm._s(_vm.$store.getters.getCompanyName))]),_vm._v("\n      v"+_vm._s(_vm.version)+"\n    ")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-building"}),_vm._v(" "+_vm._s(_vm.user.companyName)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16aa0650","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/shared/Footer.vue
// module id = 285
// module chunks = 0